//imports
import React, { Fragment, useCallback, useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';
import { useIntl } from "react-intl";

//controls
import { Container, Paper } from '@mui/material';
import Tabs, { TabContainer } from 'Components/Tabs';
import { useDispatch, useSelector } from "react-redux";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useFeatureEnabled } from 'Components/FeatureToggle';

//views
import { ContactsView, SubUserView, LoginHistoryView, ApiKeysView, TagsView, RoleView, DataExportView, WebHooks, SettingsView } from "Modules/account/views";

import { HasPermission } from "Core/security"
import { endpoints } from 'Core/defaultValues';

// Styles
import './styles.scss'
import { EVIRPX_ENABLED } from 'Modules/evirPx/.globals/constants.ts'

const AccountMainView = (props) => {
  //intl
  const { messages, locale } = useIntl();
  const dispatch = useDispatch();

  //Global state
  const user = useSelector((state) => state.securityRedux.user);
  const showEvirSettings = useFeatureEnabled(EVIRPX_ENABLED, false);

  const [view, setView] = useState("apiKeys");

  const views = (type) => {
    let types = {
      'apiKeys': <ApiKeysView showTable={refreshTable} />,
      'webHooks': <WebHooks showTable={refreshTable} />
    }
    return types[type]
  }


  const refreshTable = (newView) => {
    if (newView != view) {
      setView(newView);
    }
  };


  const getTabs = () => {
    let tabs = [
      { // TODO submodule-approved
        label: messages["menu_contacts"],
        permissions: [54],
        render: () => {
          return <ContactsView />
        }
      },
      { // TODO submodule-approved
        label: messages["menu_users"],
        permissions: [31],
        render: () => {
          return <SubUserView />
        }
      },
      { // TODO submodule-approved
        label: messages["menu_role"],
        permissions: [226],
        render: () => {
          return <RoleView />
        }
      },
      { // TODO submodule-approved
        label: messages["menu_tags"],
        permissions: [227],
        render: () => {
          return <TagsView />
        }
      },
      { // TODO submodule-approved
        label: messages["menu_loginHistory"],
        permissions: [55],
        render: () => {
          return <LoginHistoryView />
        }
      },
      { // TODO submodule-approved
        label: messages["menu_apiKeys"],
        permissions: [218],
        render: () => {
          return views(view)
        }
      },
      {
        label: messages["menu_dataExport"],
        permissions: [10],
        render: () => {
          return <DataExportView />
        }
      },
      ...(showEvirSettings ? [{
        label: messages["menu_evirSettings"],
        permissions: [364],  // ect2:read:company - View Inspection Builder
        render: () => {
          return <SettingsView />
        }
      }] : []),
    ];

    return tabs.filter(tab => HasPermission(user, tab?.master || '', tab.permissions));
  }

  return (
    <Container maxWidth={false} className="container-view">
      <Paper elevation={0}>
        <Tabs
          customButton={user && ["1", "6"].includes(user?.dealerId) ? () => {
            return (
              <div className="account-main-link-button">
                <a type="link" target="_blank" href={endpoints.BILLING_PORTAL_URL}>
                  {messages['menu_billingPortal']}
                  <OpenInNewIcon style={{ color: 'black' }} />
                </a>
              </div>
            )
          } : null}
        >
          {
            getTabs().map((tab, index) => {
              return (
                <TabContainer key={`menu-${index}`} label={tab.label} index={index}>
                  {tab.render()}
                </TabContainer>
              )
            })
          }
        </Tabs>
      </Paper>
    </Container>
  );
}

export default AccountMainView;
